export default defineNuxtPlugin(async () => {
  const config = useRuntimeConfig()

  if(config.public.MSW) {
    // @ts-ignore
    const { startWorker } = await import('../mocks/browser')
    await startWorker()
  }

})